import { ADD_PAYMENT_TO_CART_REQUEST, ADD_PAYMENT_TO_CART_SUCCESS, ADD_PAYMENT_TO_CART_ERROR } from '../constants/ActionTypes'
import { Action as ReduxAction } from 'redux'

export type AddPaymentToCartAction = ReduxAction<string> & {
    error: { message: string }
}

const addPaymentToCartError = (state = '', action: AddPaymentToCartAction) => {
    switch (action.type) {
        case ADD_PAYMENT_TO_CART_REQUEST:
        case ADD_PAYMENT_TO_CART_SUCCESS: {
            return ''
        }

        case ADD_PAYMENT_TO_CART_ERROR:
            return action.error.message

        default:
            return state
    }
}

export default addPaymentToCartError
